module.exports = {
    app_version: '0.1.1-1',
    base_routing: '/',
    // api_endpoint: 'http://localhost:8000/api', // web api
    // api_support: 'http://localhost:8002/api', // support api
    // api_export: 'http://118.98.23.246:7801', // export api

    api_endpoint: 'https://mona-api.bgessbu.com/api', // web api
    api_support: 'https://mona-support.bgessbu.com/api', // support api
    api_export: 'https://export.bgessbu.com', // export api
    get_api_export: 'http://localhost:7801', // export api

    colors: {
        red: '#C62828',
        white: '#fffcfc',
        grey: '#999999',
    }
}